import { render, staticRenderFns } from "./Registro-verify.vue?vue&type=template&id=a4ce2152&"
import script from "./Registro-verify.vue?vue&type=script&lang=js&"
export * from "./Registro-verify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports